<template>
  <section :style="{ '--onboardingcolor': color }">
    <v-tour name="onboarding" :steps=this.onboardingSteps :options="optionsob" :callbacks="myCallbacks"></v-tour>
    <div v-if="disableScreen" class="disable"></div>
  </section>
</template>
<script>

import makeonboarding from './makeonboarding'
import judgeonboarding from './judgeregistrationonboarding'
import state from '../../SectionProjectView/state'
import componentState from '@/mixins/component-state'
import { mapGetters } from 'vuex'

export default {
  name: 'onboardingmakehome',
  props: ['onboardrequest', 'pushtoPath'],
  data: function () {
    return {
      myCallbacks: {
        onStart: this.customCallbackStart,
        onStop: this.customCallbackEnd
      }
    }
  },
  mixins: [makeonboarding, judgeonboarding, componentState],
  computed: {
    ...mapGetters({
      onboardingType: 'onboardingType',
      color: 'onboardingColor',
      disableScreen: 'onboardingDisableScreen',
      onboardingStarted: 'onboardingStarted'
    }),
    optionsob: function () {
      return {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: this.$t('onboarding.judgeRegistration.skip'),
          buttonPrevious: this.$t('onboarding.judgeRegistration.previous'),
          buttonNext: this.$t('onboarding.judgeRegistration.next'),
          buttonStop: this.$t('onboarding.judgeRegistration.finish')
        }
      }
    },
    onboardingSteps: function () {
      if (this.onboardingType === 'judgeregistration') {
        return this.judgeOnBoardingSteps
      } else if (this.onboardingType === 'makehomedesktop') {
        return this.makehomedesktop
      } else {
        return this.makehomemobile
      }
    },
    tourStatus: function () {
      return this.$tours.onboarding._data.currentStep
    },
    showModal: function () {
      return this._get(state.grid.modalVisible)
    }
  },
  methods: {
    customCallbackStart: function () {
      setTimeout(function () { window.scrollTo(0, 900) }, 650)
      this.$store.dispatch('setDisableScreen', true)
      setTimeout(function () { window.scrollTo(0, 0) }, 900)
      this.$store.dispatch('startOnboarding')
    },
    customCallbackEnd: function () {
      this.$store.dispatch('setDisableScreen', false)
      this.$store.dispatch('completeOnboarding')
      if (this.$isMake) {
        if (this.onboardingStarted) {
          if (window.history.length < 2) {
            this.$router.push({ name: 'home' })
          } else {
            this.$router.go(-1)
          }
          this.$store.dispatch('completeOnboarding')
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~styles/utils.scss';

:root {
  --onboardingcolor: #00ADEE;
}

body.v-tour--active{
  pointer-events:none
}
.v-tour{
  pointer-events:auto;
}
.v-tour__target--highlighted{
  -webkit-box-shadow:0 0 0 4px rgba(0,0,0,.4);
  box-shadow:0 0 0 4px rgba(0,0,0,.4);
  pointer-events:auto;
  z-index:9999;
}
.v-tour__target--relative{
  position:relative
}
.v-step[data-v-7c9c03f0]{
  background: var(--onboardingcolor);
  color:#fff;
  max-width:320px;
  border-radius:3px;
  -webkit-filter:drop-shadow(0 0 2px rgba(0,0,0,.8));
  filter:drop-shadow(0 0 2px rgba(0,0,0,.5));
  padding:1.5rem;
  padding-bottom: 0.5rem;
  text-align:center;
  z-index:10000;
  font-size: 1.1rem;
  @include mobile {
    font-size: 0.9rem;
    padding: 1rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
}

.v-step strong {
  color: #fff;
}
.v-step .v-step__arrow[data-v-7c9c03f0]{
  width:0;
  height:0;
  border-style:solid;
  position:absolute;
  margin:.5rem;
  border-color: var(--onboardingcolor)
}
.v-step .v-step__arrow--dark[data-v-7c9c03f0]{
  border-color: var(--onboardingcolor)
}
.v-step[x-placement^=top][data-v-7c9c03f0]{
  margin-bottom:.5rem
}
.v-step[x-placement^=top] .v-step__arrow[data-v-7c9c03f0]{
  border-width:.5rem .5rem 0 .5rem;
  border-left-color:transparent;
  border-right-color:transparent;
  border-bottom-color:transparent;
  bottom:-.5rem;left:calc(50% - 1rem);
  margin-top:0;margin-bottom:0
}
.v-step[x-placement^=bottom][data-v-7c9c03f0]{
  margin-top:.5rem
}
.v-step[x-placement^=bottom] .v-step__arrow[data-v-7c9c03f0]{
  border-width:0 .5rem .5rem .5rem;
  border-left-color:transparent;
  border-right-color:transparent;
  border-top-color:transparent;
  top:-.5rem;
  left:calc(50% - 1rem);
  margin-top:0;
  margin-bottom:0
}
.v-step[x-placement^=right][data-v-7c9c03f0]{
  margin-left:.5rem
}
.v-step[x-placement^=right] .v-step__arrow[data-v-7c9c03f0]{
  border-width:.5rem .5rem .5rem 0;
  border-left-color:transparent;
  border-top-color:transparent;
  border-bottom-color:transparent;
  left:-.5rem;
  top:calc(50% - 1rem);
  margin-left:0;
  margin-right:0
}
.v-step[x-placement^=left][data-v-7c9c03f0]{
  margin-right:.5rem
}
.v-step[x-placement^=left] .v-step__arrow[data-v-7c9c03f0]{
  border-width:.5rem 0 .5rem .5rem;
  border-top-color:transparent;
  border-right-color:transparent;
  border-bottom-color:transparent;
  right:-.5rem;top:calc(50% - 1rem);
  margin-left:0;margin-right:0
}
.v-step__header[data-v-7c9c03f0]{
  margin:-1rem -1rem .5rem;
  padding:1rem;
  background-color:var(--onboardingcolor);
  border-top-left-radius:3px;
  border-top-right-radius:3px;
  padding-bottom: 0;
  text-align: left;
}

.v-step__header[data-v-7c9c03f0] span{
  font-size: 1.5rem;
  line-height: 0;
}

.v-step__content[data-v-7c9c03f0]{
  margin:0 0 1rem 0;
  text-align: left;
}
.v-step__button[data-v-7c9c03f0]{
  background:transparent;
  border:.05rem solid #fff;
  border-radius:.1rem;
  color:#fff;
  cursor:pointer;
  border: none;
  display:inline-block;
  font-size:.8rem;
  height:1.8rem;
  line-height:1rem;
  outline:none;
  margin:0 .2rem;
  padding:.35rem .4rem;
  text-align:center;
  text-decoration:none;
  -webkit-transition:all .2s ease;
  transition:all .2s ease;
  vertical-align:middle;
  white-space:nowrap;
}
.v-step__button[data-v-7c9c03f0]:hover{
  background-color:hsla(0,0%,100%,.95);
  color: var(--onboardingcolor)
}

.v-step__buttons {
  text-align: right;
}

.disable{
  background: rgba(0,0,0,.1);
  z-index: 9998;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
}

.v-step__header[data-v-7c9c03f0] .numbers {
  position: absolute;
  bottom: 22px;
  left: 25px;
  font-size: 0.9rem;
}

.v-step__header[data-v-7c9c03f0] .numbersmobile {
  position: absolute;
  bottom: 31px;
  left: 25px;
  font-size: 0.9rem;
}
</style>
